import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import { NavLink } from "react-router-dom";

import {
  BeachAccess as HomeIcon
} from "@material-ui/icons";

import useStyles from "./styles";

const SidebarItems = [
  {
    name: "Home",
    icon: <HomeIcon />,
    route: "/dashboard",
  }
];

export default function Sidebar(props) {
  const classes = useStyles();

  return (
    <>
      <List>
        {SidebarItems.map((item, index) => {
          if (item.name === "Divider") {
            return <Divider key={index}></Divider>;
          }
          return (
            <ListItem
              key={index}
              button
              component={NavLink}
              activeClassName={classes.btnDisable}
              to={item.route}
            >
              <ListItemIcon className={classes.listItemIcons}>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.name} />
            </ListItem>
          );
        })}
      </List>
    </>
  );
}
